/** @format */

import {useArchivedOrdersContext} from '../archived_orders_context_provider';
import {ArtworkColumn} from './table_coulmns/artwork_column';
import {OrderBasicDetails} from 'frontier-components';
import {Table} from '@sttark/design-system';
import {ActionColumn} from './table_coulmns/action_column';
import DateOnly from '../../../../utilities/format/date';
import {Link} from 'react-router-dom';
import React, {useState} from 'react';
import {If, Loading} from 'frontier-utilities';

// styles
import './design_list_ungrouped.scss';

export default function DesignListUngrouped() {
    const {state} = useArchivedOrdersContext();
    const {carts, loading} = state;

    const [isShowingThumbnails, setIsShowingThumbnails] = useState(true);

    const reducedDesigns = carts.reduce((uniqueDesigns, item) => {
        item.designs_orders.forEach(dos => {
            if (!uniqueDesigns.some(uniqueDos => uniqueDos.design_id === dos.design_id)) {
                dos.order = {
                    ...item
                };
                uniqueDesigns.push(dos);
            }
        });
        return uniqueDesigns;
    }, []);

    const handleToggleThumbnails = () => {
        setIsShowingThumbnails(!isShowingThumbnails);
    };

    if (loading) {
        return <Loading />;
    }

    if ((reducedDesigns.length === 0) & !loading) {
        return (
            <div className="reorder__design-list-88ty__alert">
                You don't have any archived orders yet!
            </div>
        );
    }

    return (
        <div className="reorder__design-list-88ty">
            <Table
                columns={[
                    {
                        title: (
                            <div className="table-column-title d-flex align-items-center justify-content-start">
                                <b className="m-0 p-0">Artwork</b>
                                <button
                                    className="color-accent-primary ml-2 my-0 p-0"
                                    onClick={handleToggleThumbnails}>
                                    <u>{isShowingThumbnails ? 'Hide' : 'Show'}</u>
                                </button>
                            </div>
                        ),
                        index: 'artwork',
                        key: 'artwork'
                    },
                    {
                        title: 'Type',
                        index: 'type',
                        key: 'type'
                    },
                    {
                        title: 'Last Order ID',
                        index: 'last_order_id',
                        key: 'last_order_id'
                    },
                    {
                        title: 'Date',
                        index: 'date',
                        key: 'date'
                    },
                    {
                        title: 'Description',
                        index: 'description',
                        key: 'description'
                    },
                    {
                        title: '',
                        index: 'action',
                        key: 'action'
                    }
                ]}
                rows={reducedDesigns.map(design_order => {
                    return {
                        key: design_order.id,
                        artwork: (
                            <ArtworkColumn
                                isShowingThumbnails={isShowingThumbnails}
                                designOrder={design_order}
                            />
                        ),
                        type: (
                            <div className="m-0 p-0">
                                <div className="artwork-column-27ux__table-cell">
                                    {design_order.order.product_type_label}
                                </div>
                            </div>
                        ),
                        last_order_id: (
                            <div>
                                <div className="artwork-column-27ux__table-cell">
                                    <Link to={'/account/orders/view/' + design_order.order_id}>
                                        <u>{design_order.order_id}</u>
                                    </Link>
                                    <If condition={!!design_order.order.po_number}>
                                        <p className="color-structure-darker">
                                            <b>PO:</b> #{design_order.order.po_number}
                                        </p>
                                    </If>
                                </div>
                            </div>
                        ),
                        date: (
                            <div>
                                <div className="artwork-column-27ux__table-cell">
                                    <DateOnly>{design_order.created}</DateOnly>
                                </div>
                            </div>
                        ),
                        description: (
                            <div className="table-column-76tg__description">
                                <div className="artwork-column-27ux__table-cell">
                                    <OrderBasicDetails order={design_order.order} />
                                </div>
                            </div>
                        ),
                        action: <ActionColumn designOrder={design_order} />
                    };
                })}
                className="design_ungrouped-51yf"
            />
        </div>
    );
}
